<template>
  <div v-if="isFullscreen"
       class="fullscreen-overlay"
       @click="toggleFullscreen">
  </div>

  <div :class="['fullscreen-wrapper', { fullscreen: isFullscreen }]">

    <!-- GÓRNY PASEK -->
    <div class="d-flex justify-content-between align-items-center"
         :style="{
            padding: isFullscreen ? '.5rem' : '.1rem',
            marginBottom: isFullscreen ? '5px' : '0',
            backgroundColor: isFullscreen ? 'grey' : 'white',
            position: isFullscreen ? 'sticky' : 'static',
            zIndex: isFullscreen ? '99999' : '0',
            top: isFullscreen ? '-20px' : null
         }">

      <h6 class="mb-0"
          :style="{color: isFullscreen ? 'white' : 'inherit'}">
        {{ title }}
      </h6>

      <!-- PRZYCISKI OBOK SIEBIE -->
      <div class="d-flex gap-2">
        <!-- WYCZYŚĆ FILTRY -->
        <button
          v-if="selectedArticle"
          class="btn btn-sm"
          :class="isFullscreen ? 'btn-light' : 'btn-outline-secondary'"
          @click="clearFilters">
          <i class="bi bi-x-circle me-1"></i>
          Wyczyść filtry
        </button>

        <!-- PEŁNY EKRAN -->
        <button
          class="btn btn-sm"
          :class="isFullscreen ? 'btn-light' : 'btn-outline-primary'"
          @click="toggleFullscreen">

          <template v-if="isFullscreen">
            <i class="bi bi-fullscreen-exit me-2"></i>
            Wyjdź z trybu pełnego ekranu
          </template>

          <template v-else>
            <i class="bi bi-fullscreen me-2"></i>
            Pełny ekran
          </template>

        </button>

      </div>
    </div>

    <!-- SEKCJA HISTORII -->
    <div id="preview" class="mt-5"
         style="margin-top:50px;"
         v-if="selectedArticle">

      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="mb-0">
          Historia magazynowa artykułu
          {{ selectedArticle.article.catalog_number }} -
          {{ selectedArticle.article.model }}
        </h5>
		  <div class="form-check form-switch form-switch-success d-flex align-items-center switch-item">
    <input
      class="form-check-input"
      type="checkbox"
      role="switch"
      id="showAllOnly"
      style="height:1.4em; width:2.5em;"
      :checked="showAll"
	  @change="toggleAll"
    >
    <label class="form-check-label ms-2 switch-label" for="showAllOnly">
      Pokaż wszystkie
    </label>
  </div>
      </div>

      <div class="table-responsive" style="max-height: 60vh;">

        <table class="table table-striped"
               v-if="filteredHistory.length">

          <thead>
            <tr>
              <th>Numer Dokumentu</th>
              <th>Magazyn</th>
              <th>Przychód</th>
              <th>Rozchód</th>
              <th>Pozostało</th>
              <th>Komentarz</th>
              <th>Osoba wydająca</th>
              <th>Osoba przyjmująca</th>
              <th>Cel wydania</th>
              <th>Cena PLN Netto</th>
              <th>Wartość PLN Netto</th>
              <th>Utworzony przez</th>
              <th>Data Utworzenia</th>
            </tr>

            <!-- FILTRY -->
            <tr class="filters-row">
              <th>
                <input type="text"
                       v-model="filters.document_number"
                       placeholder="Szukaj..."
                       :class="filterInputClass(filters.document_number)">
              </th>

              <th>
                <input type="text"
                       v-model="filters.warehouse"
                       placeholder="Szukaj..."
                       :class="filterInputClass(filters.warehouse)">
              </th>

              <th></th>
              <th></th>
              <th></th>

              <th>
                <input type="text"
                       v-model="filters.comment"
                       placeholder="Szukaj..."
                       :class="filterInputClass(filters.comment)">
              </th>

              <th>
                <input type="text"
                       v-model="filters.who_issuing"
                       placeholder="Szukaj..."
                       :class="filterInputClass(filters.who_issuing)">
              </th>

              <th>
                <input type="text"
                       v-model="filters.who_receiving"
                       placeholder="Szukaj..."
                       :class="filterInputClass(filters.who_receiving)">
              </th>

              <th>
                <input type="text"
                       v-model="filters.purpose"
                       placeholder="Szukaj..."
                       :class="filterInputClass(filters.purpose)">
              </th>

              <th></th>
              <th></th>

              <th>
                <input type="text"
                       v-model="filters.created_by_name"
                       placeholder="Szukaj..."
                       :class="filterInputClass(filters.created_by_name)">
              </th>

              <th>
                <div class="d-flex gap-1">
                  <input type="date"
                         v-model="filters.date_from"
                         :class="filterInputClass(filters.date_from)">
                  <input type="date"
                         v-model="filters.date_to"
                         :class="filterInputClass(filters.date_to)">
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="article in filteredHistory"
                :key="article.id">
              <td>{{ article.document_number }}</td>
              <td>{{ article.article_warehouse?.short_name }}</td>
              <td>{{ article.income }}</td>
              <td>{{ article.outcome }}</td>
              <td>{{ article.remaining_main_warehouse }}</td>
              <td>{{ article.comment }}</td>
              <td>{{ article.who_issuing }}</td>
              <td>{{ article.who_receiving }}</td>
              <td>{{ article.purpose }}</td>
              <td>{{ article.price_netto_zl }}</td>
              <td>{{ article.value_netto_zl }}</td>
              <td>{{ article.created_by_name }}</td>
              <td>{{ dateFormatter(article.created_at) }}</td>
            </tr>
          </tbody>

        </table>

        <div v-else class="text-muted mt-3">
          Brak wyników dla zastosowanych filtrów.
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment/moment.js";

export default {
  props: {
    selectedArticle: Object,
  },

  data() {
    return {
	isFullscreen: false,
	showAll: false,
      articleHistory: null,
      filters: {
        document_number: "",
        warehouse: "",
        who_issuing: "",
        who_receiving: "",
        purpose: "",
        comment: "",
        created_by_name: "",
        date_from: "",
        date_to: "",
      },
    };
  },

  watch: {
    selectedArticle: {
      immediate: true,
      handler(newArticle) {
        if (newArticle) {
          this.getHistoryData(newArticle.id);
        }
      },
    },
  },

  computed: {
filteredHistory() {
  if (!this.articleHistory) return [];

  let history = [...this.articleHistory];

  if (!this.showAll) {
    const pzOrderNumbers = history
      .filter(item =>
        item.document_number?.startsWith("PZ/")
      )
      .map(item => item.order_number)
      .filter(Boolean);

    history = history.filter(item => {
      const documentNumber = item.document_number || "";
      const isPZ = documentNumber.startsWith("PZ/");
      const isMM = documentNumber.startsWith("MM/");
      const hasMatchingOrder =
        item.order_number &&
        pzOrderNumbers.includes(item.order_number);

      const hasProperComment =
        item.purpose?.includes("Przesunięcie między magazynami");
     if (isPZ) {
        return false;
      }
      if (
        isMM &&
        hasMatchingOrder &&
        hasProperComment
      ) {
        return false;
      }

      return true;
    });
  }

  return history.filter((a) => {
    const createdAt = moment(a.created_at);

    return (
      (!this.filters.document_number ||
        a.document_number?.toLowerCase().includes(this.filters.document_number.toLowerCase())) &&

      (!this.filters.warehouse ||
        a.article_warehouse?.short_name?.toLowerCase().includes(this.filters.warehouse.toLowerCase())) &&

      (!this.filters.who_issuing ||
        a.who_issuing?.toLowerCase().includes(this.filters.who_issuing.toLowerCase())) &&

      (!this.filters.who_receiving ||
        a.who_receiving?.toLowerCase().includes(this.filters.who_receiving.toLowerCase())) &&

      (!this.filters.purpose ||
        a.purpose?.toLowerCase().includes(this.filters.purpose.toLowerCase())) &&

      (!this.filters.comment ||
        a.comment?.toLowerCase().includes(this.filters.comment.toLowerCase())) &&

      (!this.filters.created_by_name ||
        a.created_by_name?.toLowerCase().includes(this.filters.created_by_name.toLowerCase())) &&

      (!this.filters.date_from ||
        createdAt.isSameOrAfter(moment(this.filters.date_from), "day")) &&

      (!this.filters.date_to ||
        createdAt.isSameOrBefore(moment(this.filters.date_to), "day"))
    );
  });
},
  },

  methods: {
toggleAll() {
  this.showAll = !this.showAll;
},
      toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;

      // opcjonalnie blokada scrolla dokumentu
      document.body.style.overflow = this.isFullscreen ? 'hidden' : '';
    },

    getHistoryData() {
      axios
          .get(route("warehouse-movements.get.article-warehouses-movement-details", {
            article: this.selectedArticle.article,
          }))
          .then((response) => {
            this.articleHistory = response.data;
          })
          .catch((error) => {
            console.error(error);
          });
    },

    dateFormatter(date) {
      if (!date) return "";
      try {
        return moment(date).format("DD.MM.YYYY HH:mm:ss");
      } catch {
        return date;
      }
    },

    clearFilters() {
      this.filters = {
        document_number: "",
        warehouse: "",
        who_issuing: "",
        who_receiving: "",
        purpose: "",
        comment: "",
        created_by_name: "",
        date_from: "",
        date_to: "",
      };
    },

    filterInputClass(value) {
      return [
        "form-control",
        "form-control-sm",
        "filter-input",
        {active: value && value.toString().trim() !== ""},
      ];
    },
  },
};
</script>

<style scoped>
.table th,
.table td {
  font-size: 13px;
  vertical-align: middle;
}

.filters-row input.filter-input {
  height: 24px;
  font-size: 12px;
  padding: 2px 4px;
}

.filters-row th {
  background-color: #fafafa;
  border-bottom: 2px solid #ddd;
  vertical-align: middle;
}

.filter-input.active {
  border: 2px solid #28a745 !important; 
  box-shadow: 0 0 0 1px rgba(40, 167, 69, 0.3);
}

input[type="date"].filter-input {
  min-width: 100px;
  font-size: 11px;
}

.btn.btn-sm {
  padding: 3px 8px;
  font-size: 13px; 
}


.fullscreen-wrapper {
  position: relative;
  transition: all .3s ease-in-out;
}

.fullscreen-wrapper.fullscreen {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: 20px;
  background: #ffffff;
  overflow: auto;
  box-shadow: 0 0 40px rgba(0,0,0,.25);
  animation: fadeInFullscreen .2s ease-in-out;
}

.fullscreen-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1049;
}

@keyframes fadeInFullscreen {
  from {
    opacity: 0;
    transform: scale(.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
